import { Box, IconButton } from "@mui/material";
import { _ACTIONS, _HTTP } from "../../../utils/constants";
import { _ROUTES } from "../../../utils/_routes_constants";
import { SLASH } from "../../../utils/strings";
import { createToast } from "../../../utils/toast";
import { RequestHelper } from "../../../utils/requestHelper";
// ICONS //
import DeleteIcon from "@mui/icons-material/Delete";
import { EditNoteSharp } from "@mui/icons-material";

const requestHelper = new RequestHelper();

export default function ColumnBuilder(setRows, setRowData, onModalOpen) {
  const cols = [
    {
      field: "name",
      headerName: "Name",
      flex: 9,
      headerClass: "month-header",
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      headerClass: "total-header-col",
      cellRenderer: (params) => {
        return (
          <Box>
            <IconButton
              aria-label="delete"
              color="lightDanger"
              onClick={() => {
                requestHelper
                  .doRequest(
                    _ACTIONS.DELETE,
                    _ROUTES.VOLUME_FILAIRE + SLASH + params?.data.id
                  )
                  .then((res) => {
                    if (res.status === _HTTP.noContent) {
                      setRows((prev) => {
                        return prev.filter((r) => r.id !== params?.data.id);
                      });
                      createToast(
                        "success",
                        "Volume filaire deleted successfully"
                      );
                    }
                  })
                  .catch(() => {
                    createToast(
                      "error",
                      "An error occurred while deleting the volume filaire"
                    );
                  });
              }}
            >
              <DeleteIcon />
            </IconButton>
            <IconButton
              aria-label="edit"
              color="warning"
              onClick={() => {
                onModalOpen("edit");
                setRowData(params?.data);
              }}
            >
              <EditNoteSharp />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  return cols;
}
